export default {
      id: "menu__reports-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#menu__reports",
      toString: function () {
        return this.url;
      }
    }